import React from "react";
import AppShell from "./appShell";
import PropTypes from 'prop-types';

export default function MainLayout(props){
    return <AppShell page={props.page} {...props}/>
}
MainLayout.propTypes = {
    page: PropTypes.node
}